class TestimonialsController {
  constructor() {
    'ngInject';

    this.background = 'https://cs7059.vk.me/c604518/v604518254/3a85a/30gmpkOKxf8.jpg';
    this.text = [["Reschedule todays meeting to Thursday at 11:00"], ["More convenient for JC and HJ", "Permits DC to attend", "Room free"]];
    this.answers = [[0, 1], [0, 2], [0, 3]];
    this.completed = true;
    this.section = 1;
    this.exercise = 1;

  }
}

export default TestimonialsController;



// WEBPACK FOOTER //
// ./client/app/modules/site/testimonials/testimonials.controller.js